<div class="features-3 mt-5">
    <div class="container">






        <div class="row">


            <!-- <div class="col-md-5 ml-auto mr-auto text-center justify-content-center align-items-center">
        <div class="row">
          <div class="container">
            <h3 class="title">More of Our Services and Integration Options...</h3>
          </div>
        </div>
        
      </div> -->

            <div class="col-md-12">

                <div class="row">




                    <div class="col-md-4">

                        <div class="info info-horizontal">
                            <div class="icon icon-warning">
                                <i class="nc-icon nc-www"></i>
                            </div>
                            <div class="description">



                                <a href="https://www.doctorsnearme.co.za/index">

                                    <img class="mt-1 mb-1" style="max-height: 50px;" alt=""
                                        src="./assets/img/brand/doctorsnearme2.png">

                                </a>


                                <p>Find doctors near you</p>



                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">



                        <p class="font-weight-bold">Healthcare Providers</p>
                        <hr>
                        <ul>
                            <li>Virtual tel-e-consults®</li>
                            <li>Online Calendar</li>
                            <li>Promote your Practice</li>
                            <li>Visit www.doctorsnearme.co.za
                                to register</li>
                            <li>Personalized practice website to
                                assist in bookings and visibility</li>
                        </ul>
                    </div>

                    <div class="col-md-4">
                        <p class="font-weight-bold">Patients</p>
                        <hr>
                        <ul>
                            <li>Comprehensive Electronic Medical Records</li>

                            <li>Medical History</li>
                            <li>Pathology Results with Graphs</li>
                            <li>Online Medical Appointments</li>


                        </ul>

                        
                                <a href="https://www.doctorsnearme.co.za/index" class="btn btn-primary btn-round mt-2 ms-auto me-auto text-center">

                                    Register for free

                                </a>

                    </div>

                </div>

            </div>
        </div>
    </div>
</div>